export var BannerType;
(function (BannerType) {
    BannerType["Render"] = "Render";
    BannerType["Info"] = "Info";
    BannerType["Known"] = "Known";
})(BannerType || (BannerType = {}));
//# sourceMappingURL=banner.js.map